import React, { useEffect, useState, useMemo } from 'react';
import s from './AccountTopUp.module.css';
import { Popover } from "antd";
import infoIcon from "../../../../assets/images/personalAccount/info.svg";
import CustomDropdownForAccounts from "../../../../components/ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import { useAppDispatch } from "../../../../hooks/redux";
import { Formik, useFormikContext } from "formik";
import { setFilters, setFiltersTemplates } from "../../../../store/reducers/TransactionsSlice/TransactionsSlice";
import { useSelector } from "react-redux";
import { selectAccountsByFilter, selectIsCentiWiseEnabledByAccount, selectTopUpByAccount } from "../../../../store/reducers/TransactionsSlice/selector";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import PersonalIban from "./PersonalIban/PersonalIban";
import CorrespondentAccount from "./CorrespondentAccount/CorrespondentAccount";
import { brandConfig } from '../../../../config/config';
// import TopUpByCard from './TopUpByCard/TopUpByCard';
import TopUpByBankOrMobile from './TopUpByBankOrMobile/TopUpByBankOrMobile';

const AutoSubmitComponent = () => {
    const { values, submitForm } = useFormikContext();

    useEffect(() => {
        submitForm();
    }, [values, submitForm]);

    return null;
};

export const AccountTopUp = () => {
    const accountsList = useSelector(selectAccountsByFilter);
    const accountTopUpList = useSelector(selectTopUpByAccount);
    const isCentiwiseEnabled = useSelector(selectIsCentiWiseEnabledByAccount);
    const dispatch = useAppDispatch();
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        // Check if main iber account exists (currently commented out but keeping variable for potential future use)
        // const hasMainIberAccount = accountTopUpList?.iber?.some((item:any) => item.isMain);
        
        // if (hasMainIberAccount && tabIndex !== 1) {
        //     setTabIndex(1);
        // }

        return () => {
            dispatch(setFiltersTemplates({
                accountNumber: '',
                period: null,
                from: '',
                to: '',
                purpose: '',
                recipient: '',
                amount: '',
                incoming: false,
                outgoing: false,
                currency: '',
                selectedType: '',
                templateName: '',
                paymentRegion: ''
            }));
        };
    }, [accountTopUpList, dispatch]);

    const renderedTabs = useMemo(() => (
        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(() => index)}>
            <TabList className={s.tabstitle_block}>
                {accountTopUpList?.virtual?.length > 0 && (
                    <Tab selectedClassName={s.active_tab} className={s.tabtitle}>
                        Personal IBAN
                    </Tab>
                )}
                {accountTopUpList?.iber?.length > 0 && (
                    <Tab selectedClassName={s.active_tab} className={s.tabtitle}>
                        {brandConfig.companyNameSimple} Correspondent Account
                    </Tab>
                )}
                {isCentiwiseEnabled && (
                    <>
                        {/* <Tab selectedClassName={s.active_tab} className={s.tabtitle}>Top-Up by Card</Tab> */}
                        <Tab selectedClassName={s.active_tab} className={s.tabtitle}>Top-Up by Link</Tab>
                    </>
                 )} 
            </TabList>
            {accountTopUpList?.virtual?.length > 0 && (
                <TabPanel>
                    <PersonalIban list={accountTopUpList?.virtual} />
                </TabPanel>
            )}
            {accountTopUpList?.iber?.length > 0 && (
                <TabPanel>
                    <CorrespondentAccount list={accountTopUpList?.iber} />
                </TabPanel>
            )}
            {/* {isCentiwiseEnabled && ( */}
                {/* <TabPanel>
                    <TopUpByCard paymentMethod='1' />
                </TabPanel> */}
            {/* )} */}
            {isCentiwiseEnabled && (
                <TabPanel>
                    <TopUpByBankOrMobile paymentMethod='2' />
                </TabPanel>
            )} 
        </Tabs>
    ), [tabIndex, accountTopUpList, isCentiwiseEnabled]);

    return (
        <div className={s.accountTopUpWrapper}>
            <Formik initialValues={{ accountNumber: '' }}
                onSubmit={(values) => {
                    dispatch(setFilters({ accountNumber: values.accountNumber }));
                }}
            >
                {({
                    values,
                    handleChange,
                    handleSubmit
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className={s.detailsWrapper}>
                            <p className={s.detailsTitle}>Details for the Bank Transfer</p>
                            <div>
                                <p className={s.labelText}>
                                    Payer account
                                    <Popover
                                        content={"Your internal account number."}
                                        color={'#EEEFEF'}
                                        placement={"bottom"}
                                        overlayInnerStyle={{
                                            fontFamily: 'Inter',
                                            padding: '13px 16px',
                                            backgroundColor: '#EEEFEF',
                                            boxShadow: 'none'
                                        }}
                                    >
                                        <img src={infoIcon} alt="" />
                                    </Popover>
                                </p>
                                <CustomDropdownForAccounts
                                    items={accountsList}
                                    id='accountNumber'
                                    name='accountNumber'
                                    placeholder={"Please select the account"}
                                />
                            </div>

                            {
                            (accountTopUpList?.virtual?.length > 0 || accountTopUpList?.iber?.length > 0 || isCentiwiseEnabled) &&
                                renderedTabs
                            }
                        </div>

                        <AutoSubmitComponent />
                    </form>
                )}
            </Formik>
        </div>
    );
};
